import { FC } from "react";

import { PaymentRequestCard } from "../../cards";
import { useGetPaymentRequestsQuery } from "../../../store/services/paymentRequests";
import {
  PaymentRequest,
  PaymentRequestStatus,
} from "../../../types/PaymentRequestTypes";
import { generatePdfDocument } from "../../../utils/actions/generatePdfDocument";
import { PDFPaymentRequest } from "../../pdf";

export const PaymentRequestList: FC = () => {
  const { data: paymentRequests } = useGetPaymentRequestsQuery();

  if (!paymentRequests || paymentRequests.results.length === 0) {
    return null;
  }

  const handleClick = (paymentRequest: PaymentRequest) => {
    const { id, status } = paymentRequest;
    if (status === PaymentRequestStatus.PAID) {
      generatePdfDocument(
        <PDFPaymentRequest data={paymentRequest} />,
        `Transfer-${id.substring(id.length - 4)}`
      );
    }
  };

  return (
    <div className="flex flex-col px-4 gap-2">
      <h4 className="pt-4 font-extrabold">Transfers history</h4>

      {paymentRequests?.results.map((paymentRequest) => (
        <PaymentRequestCard
          key={paymentRequest.id}
          data={paymentRequest}
          onClick={() => handleClick(paymentRequest)}
        />
      ))}
    </div>
  );
};
